import MasterCustomerFormView from './master-form-view'

export { MasterCustomerFormView }
